/**
 * Recipe search (Foodies)
 *
 * Reads a JSON index of foodies metaobjects embedded in the page by
 * sections/recipe-search.liquid (script[data-recipe-index]) and provides
 * a live, client-side dropdown search over titles, descriptions,
 * ingredients, related collections, etc.
 */

function initRecipeSearch() {
    const roots = document.querySelectorAll('[data-recipe-search]');
    if (!roots.length) return;

    // Parse the index once (shared across all instances on the page).
    let INDEX = [];
    try {
        const raw = document.querySelector('script[data-recipe-index]');
        if (raw) INDEX = JSON.parse(raw.textContent);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn('[recipe-search] Failed to parse recipe index', e);
    }

    roots.forEach((form) => setup(form, INDEX));
}

function setup(form, INDEX) {
    const input    = form.querySelector('[data-recipe-search-input]');
    const results  = form.querySelector('[data-recipe-search-results]');
    const clearBtn = form.querySelector('[data-recipe-search-clear]');
    const limit    = parseInt(form.dataset.limit, 10) || 8;
    const minChars = parseInt(form.dataset.minChars, 10) || 2;

    if (!input || !results) return;

    let debounce    = null;
    let activeIndex = -1;

    input.addEventListener('input', () => {
        clearTimeout(debounce);
        const q = input.value.trim();
        if (clearBtn) clearBtn.hidden = q.length === 0;
        if (q.length < minChars) { hide(); return; }
        debounce = setTimeout(() => runSearch(q), 80);
    });

    input.addEventListener('focus', () => {
        if (input.value.trim().length >= minChars && results.children.length) show();
    });

    input.addEventListener('keydown', (e) => {
        const items = results.querySelectorAll('.recipe-search__result');
        if (e.key === 'Enter') {
            e.preventDefault();
            if (activeIndex >= 0 && items[activeIndex]) {
                window.location.href = items[activeIndex].href;
            } else if (items.length) {
                window.location.href = items[0].href;
            }
            return;
        }
        if (!items.length) return;
        if (e.key === 'ArrowDown')      { e.preventDefault(); move(1, items); }
        else if (e.key === 'ArrowUp')   { e.preventDefault(); move(-1, items); }
        else if (e.key === 'Escape')    { hide(); input.blur(); }
    });

    if (clearBtn) {
        clearBtn.addEventListener('click', () => {
            input.value = '';
            clearBtn.hidden = true;
            hide();
            input.focus();
        });
    }

    document.addEventListener('click', (e) => {
        if (!form.contains(e.target)) hide();
    });

    function runSearch(q) {
        const needles = q.toLowerCase().split(/\s+/).filter(Boolean);
        if (!needles.length) { hide(); return; }

        const matches = [];
        for (let i = 0; i < INDEX.length; i++) {
            const item = INDEX[i];
            const hay = item.search || '';
            let ok = true;
            let titleHits = 0;
            for (let n = 0; n < needles.length; n++) {
                if (hay.indexOf(needles[n]) === -1) { ok = false; break; }
                if ((item.title || '').toLowerCase().indexOf(needles[n]) !== -1) titleHits++;
            }
            if (ok) matches.push({ item, score: titleHits });
        }
        matches.sort((a, b) => b.score - a.score);
        render(matches.slice(0, limit), q);
    }

    function render(matches, q) {
        results.innerHTML = '';
        activeIndex = -1;

        if (!matches.length) {
            empty(`Geen recepten gevonden voor "${escapeHtml(q)}".`);
            return;
        }

        matches.forEach((m) => {
            const item = m.item;
            const meta = [item.gang, item.keuken].filter(Boolean).join(' · ');
            const a = document.createElement('a');
            a.className = 'recipe-search__result';
            a.href = item.url;
            a.setAttribute('role', 'option');
            a.innerHTML =
                (item.image ? `<img src="${escapeAttr(item.image)}" alt="" loading="lazy">` : '') +
                '<div>' +
                    `<div class="recipe-search__result-title">${highlight(item.title || '', q)}</div>` +
                    (item.excerpt ? `<div class="recipe-search__result-excerpt">${escapeHtml(item.excerpt)}</div>` : '') +
                    (meta ? `<div class="recipe-search__result-meta">${escapeHtml(meta)}</div>` : '') +
                '</div>';
            results.appendChild(a);
        });
        show();
    }

    function highlight(text, q) {
        const safe = escapeHtml(text);
        const parts = q.split(/\s+/).filter(Boolean).map(escapeRegex);
        if (!parts.length) return safe;
        return safe.replace(new RegExp('(' + parts.join('|') + ')', 'gi'), '<mark>$1</mark>');
    }
    function escapeRegex(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
    function escapeHtml(s)  {
        return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    }
    function escapeAttr(s) { return escapeHtml(s); }
    function move(delta, items) {
        activeIndex = (activeIndex + delta + items.length) % items.length;
        items.forEach((el, i) => el.setAttribute('aria-selected', i === activeIndex ? 'true' : 'false'));
        items[activeIndex].scrollIntoView({ block: 'nearest' });
    }
    function empty(m) { results.innerHTML = `<div class="recipe-search__empty">${m}</div>`; show(); }
    function show()   { results.hidden = false; }
    function hide()   { results.hidden = true; activeIndex = -1; }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRecipeSearch);
} else {
    initRecipeSearch();
}

// Re-init on Shopify theme editor section load (for editor previews).
document.addEventListener('shopify:section:load', (e) => {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-recipe-search]')) {
        initRecipeSearch();
    }
});

